import PopupOffer from './PopupOffer';

export default PopupOffer;
